<div class="custom-select" [class.open]="isOpen">
  <button
    type="button"
    class="custom-select__trigger"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="ariaLabel || null"
    aria-haspopup="listbox"
  >
    <span>{{ selectedLabel }}</span>
    <svg class="custom-select__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <ul class="custom-select__panel" role="listbox" *ngIf="isOpen">
    <li
      *ngIf="showPlaceholderOption"
      role="option"
      class="custom-select__option"
      [class.active]="value === null"
      (click)="select(null)"
    >
      {{ placeholder }}
    </li>
    <li
      *ngFor="let option of options"
      role="option"
      class="custom-select__option"
      [class.active]="value === option.key"
      (click)="select(option.key)"
    >
      {{ option.pageName }}
    </li>
  </ul>
</div>
